exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-info[data-v-6dbdd7a0]{font-size:14px;color:#606266}.selected-info .highlight[data-v-6dbdd7a0]{color:#409eff;font-weight:bold}", ""]);

// exports
